export default {
  bdtx_get_overview_chosen_module: '/bdtx/choose-module/api/overview-chosen',
  bdtx_get_choose_module: '/bdtx/choose-module/api/list',
  bdtx_update_choose_module: '/bdtx/choose-module/api/update',
  bdtx_get_deployment_status_to_unchoosing:
    '/bdtx/choose-module/api/get-deployment-status-for-module-before-cancelling',
  bdtx_cancel_chosen_module_for_organization:
    '/bdtx/choose-module/api/cancel-chosen-module-for-organization',
};
